document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".category-collection-link");
  let visibleCount = 0;

  links.forEach((link, index) => {
    if (index < 4) {
      link.style.display = "block";
      visibleCount++;
    }
  });

  if (links.length > 4) {
    const seeAllButton = document.getElementById("see-all");
    if (seeAllButton) {
      seeAllButton.style.display = "block";
      seeAllButton.addEventListener("click", () => {
        links.forEach((link) => link.style.display = "block");
        seeAllButton.style.display = "none";
      });
    }
  }

  const showMoreButton = document.querySelector(".collection-hero-show-more-js");
  if (showMoreButton) {
    showMoreButton.addEventListener("click", function () {
      const descriptionElement = document.querySelector(".collection-hero__description");
      const descriptionShort = document.querySelector(".collection-hero__short-description");
      if (descriptionElement) {
        descriptionShort.classList.toggle("inactive");
        descriptionElement.classList.toggle("active");
        if (descriptionElement.classList.contains("active")) {
          showMoreButton.innerHTML = "Hide";
        } else {
          showMoreButton.innerHTML = "See more";
        }
      }
    });
  }
});


document.querySelectorAll('input[name="viewType"]').forEach((input) => {
  input.addEventListener("change", function () {
    const productGrid = document.querySelector(".product-grid");
    if (this.value === "grid-view") {
      productGrid.classList.add("view-grid");
      productGrid.classList.remove("line-view");
    } else if (this.value === "line-view") {
      productGrid.classList.add("line-view");
      productGrid.classList.remove("view-grid");
    }
  });
});

const filterButton = document.querySelector('.filter-popup-button');
const closeButton = document.querySelector('.category-with-filters__close');
const categoryFilters = document.querySelector('.category-with-filters');
const applyButton = document.querySelector('.apply-button-popup');
const bodyFilters = document.body;
const facetsAfter = document.querySelector('.facets-vertical-after')

function openFilters() {
    categoryFilters.classList.add('active');
    bodyFilters.classList.toggle('overflow-hidden'); 
    facetsAfter.classList.add('active');
}

function closeFilters() {
    categoryFilters.classList.remove('active');
    bodyFilters.classList.remove('overflow-hidden');
    facetsAfter.classList.remove('active');
}

filterButton.addEventListener('click', function(event) {
    event.stopPropagation(); 
    openFilters();
});

closeButton.addEventListener('click', function(event) {
    event.stopPropagation();
    closeFilters();
});

applyButton.addEventListener('click', function(event) {
  event.stopPropagation();
  closeFilters();
});

document.addEventListener('click', function(event) {
    const isClickInside = categoryFilters.contains(event.target);

    if (!isClickInside) {
        closeFilters();
    }
});
